module.exports = __webpack_public_path__ + "img/juliaAndAlexanderRing.7715cdf.jpg";